import { PRINT_STATUS_YES } from '@/utils/examinations.config.js'

/** screenshots.status 的關鍵影像值；集中在一處供報告工作站與準列印共用。 */
export const KEY_IMAGE_STATUS = String(PRINT_STATUS_YES)

export const REPORT_IMAGE_CATEGORY = Object.freeze({
  UNSELECTED: 'unselected',
  KEY: 'key',
  ADDITIONAL: 'additional',
})

export function isKeyImageSelected(image) {
  return String(image && image.status) === KEY_IMAGE_STATUS
}

/**
 * 報告與列印的共同守衛：只有 DB status=1 的圖片能進關鍵影像集合。
 * 不在這裡排序，讓工作站與列印各自保留既有的顯示順序。
 */
export function selectedReportImages(images) {
  return (Array.isArray(images) ? images : []).filter(isKeyImageSelected)
}

/**
 * 一張已選影像只有在指向目前仍存在的 Finding 時才是「關鍵影像」；否則會進
 * 「更多影像」。工作站與列印必須共用這個判準，否則卡片顏色會和列印位置不一致。
 *
 * findings 可接受 parseEvas2Findings 的 `{ no }`，或列印 model 的 `{ id }`。
 */
export function isAssignedToReportFinding(image, findings, findingKey = 'evas2_finding_no') {
  const assigned = Number(image && image[findingKey])
  if (!Number.isFinite(assigned) || assigned <= 0) return false

  return (Array.isArray(findings) ? findings : []).some((finding) => {
    const id = Number(finding && (finding.no != null ? finding.no : finding.id))
    return Number.isFinite(id) && id === assigned
  })
}

export function reportImageCategory(image, findings, findingKey = 'evas2_finding_no') {
  if (!isKeyImageSelected(image)) return REPORT_IMAGE_CATEGORY.UNSELECTED
  return isAssignedToReportFinding(image, findings, findingKey)
    ? REPORT_IMAGE_CATEGORY.KEY
    : REPORT_IMAGE_CATEGORY.ADDITIONAL
}
